import React from "react";
import { InputRangeRow } from "./index";
// Used by Hacoba NSA-HS and Taining S41 machines

export default function ImpulseSettingRow() {
   return (
      <InputRangeRow
         titleProp={"Impulse Setting"}
         sizeProp={4}
         typeProp={"text"}
         minProp={1}
         maxProp={4700}
         propertyNameProp={"impulseSet"}
         errorDialogueProp={"1-4,700 only"}
         floatProp={false}
      />
   );
}
